<template lang="pug">

  .form-group
    .form-check
      input#addiesaasUserInputSmsSubscribeCheckbox(v-model="form.sms_subscribe" type="checkbox" name="sms_subscribe")
      label(for="addiesaasUserInputSmsSubscribeCheckbox")
        span.text-muted {{ label }}

</template>

<script>

export default {
  name: 'user-input-sms-subscribe',

  props: {
    label: {
      type: String,
      default: 'Receive promotional emails and news via text messages',
    },
  },

  data: () => ({
    form: null,
  }),

  async created() {
    this.form = this.$parent.form;
    this.form.sms_subscribe = this.$parent.user ? this.$parent.user.meta.sms_subscribe : '';
  },
}

</script>
